export const SELECT_ITEM = 'SELECT_ITEM'
export const SELECT_ALLITEMS = 'SELECT_ALLITEMS'
export const FILTER_BY_EVENTTYPE = 'FILTER_BY_EVENTTYPE'
export const CLEAR_FILTER = 'CLEAR_FILTER'
export const CLEAR_ALL_FILTERS = 'CLEAR_ALL_FILTERS'

export const initialState = {
  managerClients: {
    'Staff Member': [],
    Location: [],
    Trainer: [],
    Query: '',
  },
  calendar: {
    'Staff Member': [],
    Location: [],
    'Class Type': [],
    'Choose Client': [],
    'Choose Reservation': [],
    'Select Space': [],
    eventType: 'all',
  },
  createEvent: {
    'Class Type': [],
    'Choose Trainer': [],
    'Choose Client': [],
    'Choose Reservation': [],
    'Booking Type': [],
    Location: [],
    PDF: [],
    eventType: 'class',
  },
}

const filtersReducer = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_ITEM: {
      let selection = state[action.origin][action.filterName].slice()
      const index = selection.map((el) => el.id).indexOf(action.selected.id)
      if (index < 0) {
        // adding to filter
        selection = action.allowMultiple ? selection : []
        const newSelection = [...selection, action.selected]
        return {
          ...state,
          [action.origin]: {
            ...state[action.origin],
            'Choose Reservation':
              action.filterName === 'Location' ? [] : state[action.origin]['Choose Reservation'],
            'Select Space':
              action.filterName === 'Location'
                ? []
                : action.filterName === 'Choose Reservation'
                  ? state[action.origin]['Select Space'].filter((location) =>
                      newSelection.some((amenity) => location.amenityId === amenity.id),
                    )
                  : state[action.origin]['Select Space'],
            [action.filterName]: newSelection,
          },
        }
      } else {
        // removing from filter
        selection = action.allowMultiple
          ? selection.filter((item) => item.id !== action.selected.id)
          : []
        return {
          ...state,
          [action.origin]: {
            ...state[action.origin],
            'Choose Reservation':
              action.filterName === 'Location' ? [] : state[action.origin]['Choose Reservation'],
            'Select Space':
              action.filterName === 'Location'
                ? []
                : action.filterName === 'Choose Reservation'
                  ? state[action.origin]['Select Space'].filter((location) =>
                      selection.some((amenity) => location.amenityId === amenity.id),
                    )
                  : state[action.origin]['Select Space'],
            [action.filterName]: selection,
          },
        }
      }
    }
    case SELECT_ALLITEMS:
      return {
        ...state,
        [action.origin]: {
          ...state[action.origin],
          [action.filterName]: [],
        },
      }
    case FILTER_BY_EVENTTYPE:
      return {
        ...state,
        [action.origin]: {
          ...state[action.origin],
          eventType: action.eventType,
        },
      }
    case CLEAR_FILTER:
      return {
        ...state,
        [action.origin]: {
          ...state[action.origin],
          [action.filterName]: [],
        },
      }
    case CLEAR_ALL_FILTERS:
      return {
        ...state,
        [action.origin]: initialState[action.origin],
      }
    default:
      return state
  }
}

export const selectAllItems = (origin, filterName) => {
  return {
    type: SELECT_ALLITEMS,
    origin,
    filterName,
  }
}
export const selectItem = (origin, filterName, selected, allowMultiple) => {
  return {
    type: SELECT_ITEM,
    origin,
    filterName,
    selected,
    allowMultiple,
  }
}

export const filterByEventType = (origin, eventType) => {
  return {
    type: FILTER_BY_EVENTTYPE,
    origin,
    eventType,
  }
}

export const clearFilter = (origin, filterName) => {
  return {
    type: CLEAR_FILTER,
    origin,
    filterName,
  }
}

export const clearAllFilters = (origin) => {
  return {
    type: CLEAR_ALL_FILTERS,
    origin,
  }
}

export default filtersReducer
